import { render, staticRenderFns } from "./WordUpload.vue?vue&type=template&id=7a5ddc62&scoped=true"
import script from "./WordUpload.vue?vue&type=script&lang=js"
export * from "./WordUpload.vue?vue&type=script&lang=js"
import style0 from "./WordUpload.vue?vue&type=style&index=0&id=7a5ddc62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5ddc62",
  null
  
)

export default component.exports